import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Anchor, Lock } from "lucide-react";
import { useT } from "@/lib/i18n";
import { VisaLogo, MastercardLogo, TroyLogo } from "@/components/PaymentLogos";
import { DESTINATIONS_NAV } from "@/lib/destinations";
import http from "@/lib/api";

export default function Footer() {
  const { t } = useT();
  // Pull live destinations so the footer auto-adjusts when admin renames slugs.
  const [destinations, setDestinations] = useState(DESTINATIONS_NAV);
  useEffect(() => {
    http.get("/destinations")
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length > 0) {
          setDestinations(r.data.map((d) => ({
            slug: d.slug,
            name: (d.name || "").replace(/\s+(adası|adasi|island)$/i, "").trim() || d.name,
          })));
        }
      })
      .catch(() => { /* keep static fallback */ });
  }, []);
  return (
    <footer className="bg-[hsl(var(--ink))] text-[hsl(var(--bone))] mt-32" data-testid="site-footer">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2 text-3xl font-serif">
              <Anchor className="w-7 h-7" strokeWidth={1.3} />
              <span className="font-light">adalarda<span className="font-medium">tatil</span></span>
            </Link>
            <p className="mt-6 max-w-md text-white/60 leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="accent-line mt-8" />
            <div className="mt-8 text-xs text-white/55 leading-relaxed space-y-1">
              <p className="font-medium text-white/70">Scrup Turizm Seyahat Ve Bilişim Ticaret Limited Şirketi</p>
              <p>Cumhuriyet Mah. Hükümet Cad. 17/231</p>
              <p>Fethiye / Muğla</p>
              <p>TURSAB No: 17559</p>
            </div>
          </div>
          <div className="md:col-span-2">
            <h4 className="label-tiny opacity-60 mb-4">{t("footer.popular")}</h4>
            <ul className="space-y-2 text-sm text-white/80">
              {destinations.slice(0, 5).map((d) => (
                <li key={d.slug}>
                  <Link to={`/destinasyon/${d.slug}`} data-testid={`footer-dest-${d.slug}`}>{d.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <h4 className="label-tiny opacity-60 mb-4">{t("footer.services")}</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li><Link to="/feribot">{t("nav.ferry")}</Link></li>
              <li><Link to="/otel">{t("nav.hotel")}</Link></li>
              <li><Link to="/tur">{t("nav.tour")}</Link></li>
              <li><Link to="/arackiralama">{t("nav.car")}</Link></li>
              <li><Link to="/vize">{t("nav.visa")}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h4 className="label-tiny opacity-60 mb-4">{t("footer.contact")}</h4>
            <p className="text-sm text-white/80">Çağrı Merkezi</p>
            <a href="tel:+905453249892" className="text-2xl font-serif mt-1 block">0545 324 98 92</a>
            <p className="mt-6 text-sm text-white/60">{t("footer.support")}</p>
          </div>
        </div>
        <div className="dashed-divider opacity-20 my-16" />

        {/* Güvenli Ödeme & Kart Markaları (Akbank Sanal POS uyumu) */}
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-10" data-testid="payment-strip">
          <div className="flex items-center gap-2 text-white/70">
            <Lock className="w-4 h-4" />
            <span className="text-sm">Güvenli Ödeme · 3D Secure · SSL</span>
          </div>
          <div className="flex items-center gap-2 md:ml-auto">
            <VisaLogo className="h-7" />
            <MastercardLogo className="h-7" />
            <TroyLogo className="h-7" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-4 justify-between text-xs text-white/50 label-tiny">
          <span>© {new Date().getFullYear()} Adalarda Tatil — {t("footer.rights")}</span>
          <div className="flex gap-6">
            <Link to="/gizlilik" data-testid="footer-privacy-link">{t("footer.privacy")}</Link>
            <Link to="/kosullar" data-testid="footer-terms-link">{t("footer.terms")}</Link>
            <Link to="/mesafeli-satis" data-testid="footer-dsa-link">Mesafeli Satış</Link>
            <Link to="/iletisim">{t("footer.contact")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
